import styled from 'styled-components';

export const GeneralFormItemsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;

  & > div:first-child {
    margin-right: 60px;
  }

  @media only screen and (max-width: 480px) {
    & > div:first-child {
      margin-right: 0;
    }
  }
`;

export const MainWrapper = styled.div`
  & > div:first-child {
    margin-bottom: 16px;
  }
`;

export const UploadWrapper = styled.div`
  margin-top: 22px;

  & > div:last-child {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-top: 16px;
    margin-bottom: 24px;
  }

  button {
    width: 288px;
    justify-content: center;
  }

  @media (max-width: 768px) {
    .ant-row {
      display: block;
    }
  }
`;
